import { Cart } from "./schema";

export const getCartTotal = (cart?: Cart | null): number => {
  if (!cart) return 0;

  return (
    cart.items
      .map((d) => d.multiplier * d.totalSalesPriceTaxInclusive)
      .reduce((a, b) => a + b, 0) || 0
  );
};
